import { useForm } from '@inertiajs/inertia-react';
import useCForm from 'app/components/hooks/useCForm';
import Icon from 'app/components/Icon';
import { MODALS, ModalsContext } from 'app/components/Layouts/Modals';
import { ProjectType } from 'app/components/Types/ProjectType';
import { TaskType } from 'app/components/Types/TaskType';
import { UserType } from 'app/components/Types/UserType';
import React, { useContext, useEffect } from 'react'
import route from 'ziggy-js';
import DateTimeInput from '../Forms/DateTimeInput';
import Form from '../Forms/Form';
import { SearchCard } from '../Forms/Search';
import SearchMultiple from '../Forms/SearchMultiple';
import Select from '../Forms/Select';
import SelectMultiple from '../Forms/SelectMultiple';
import Submit from '../Forms/Submit';
import TextField from '../Forms/TextField';
import CloseBtn from './CloseBtn';
import ModalLayout from './ModalLayout';

interface Props {
    task: TaskType
}

function EditTask(props: Props) {
    const { task } = props


    const form = useCForm({
        name: task.name,
        project: [task.project.id] as any,
        users: task?.users?.map(u => u.id) ?? [],
        deadline: task.deadline,
        estimate: task.estimate,
        upper_estimate: task.upper_estimate,
        archived: task.archived
    });
    const { data, post, transform } = form;
    let { open, close } = useContext(ModalsContext)


    const submit = (e) => {
        e.preventDefault();
        transform(({ project, ...d }) => ({ ...d, project_id: project[0] }));
        post(route('tasks.update', { task: task.id }), {onSuccess: () => close()});
    }

    return (
        <ModalLayout>
            <div className='p-20px pt-67px relative bg-gray rounded-default w-1/3 mob:w-full'>
                <CloseBtn />
                <div className='text-18 mb-12px text-white'>Editing {task.name}</div>
                <Form form={form} onSubmit={submit}>
                    <TextField placeholder='Enter name' label={"Task name"} name="name" />
                    <SearchMultiple<ProjectType>
                        label="Project"
                        include={[task.project]}
                        keyName="search_projects"
                        name="project"
                        max={1}
                        optionsCallback={(r) => ({
                            text: r.name,
                            element: (
                                <SearchCard name={r.name} image={null} href={"#"} />
                            ),
                            value: r.id,
                        })}
                        placeholder="Choose a project" />
                    <SearchMultiple<UserType>
                        name="users"
                        label={"Team"}
                        keyName="search_users"
                        include={task.users}
                        optionsCallback={(r) => ({
                            text: r.name,
                            element: (
                                <SearchCard name={r.name} image={r.thumbnail} href={"#"} />
                            ),
                            value: r.id,
                        })} />
                    <DateTimeInput placeholder='01. 10. 2022' label={"Deadline"} name="deadline" />
                    <TextField placeholder='00:00:00' label={"Estimate"} name="estimate" />
                    <TextField placeholder='00:00:00' label={"Upper estimate"} name="upper_estimate" />
                    <Submit className='w-full' value="Save" />
                </Form>
            </div>
        </ModalLayout>
    )
}

export default EditTask
